export default "__VITE_ASSET__CfGcJTab__"